import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/order/pending-orderer-confirms`;

const list = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export default { list };
